$(function(){
    $('.accordion__title').click(function () {
        var accordion_parent = $(this).parent();
        var accordion_content = accordion_parent.find('.accordion__content');
        var accordion_content_height = $(this).parent().find('.accordion__padding')[0].scrollHeight;
        
        $(this).toggleClass('accordion__title--open');
        accordion_content.toggleClass('accordion__content--open');
        accordion_content.css('max-height', accordion_content_height);

        if (accordion_parent.attr('aria-expanded') === 'true' ) {
            accordion_parent.attr('aria-expanded', 'false');
            accordion_content.css('max-height', '0');
        } else {
            accordion_parent.attr('aria-expanded', 'true');
        }

    });

    $('.card__title--toggle').on('click', function() {
        $(this).toggleClass('card__title--toggle--active');
        // $(this).parent().find('.card__description').toggleClass('card__description--visible');
        $(this).closest('.card').toggleClass('card--expand');
    });



    $('.table-accordion__title').click(function () {
        var rowId = $(this).attr("data-number");
        var tst = '*[data-numb="' + rowId + '"]'; 
        var content = $('*[data-num="' + rowId + '"]');
        
        console.log("Accordion content: %o", content);

        if (content.hasClass("table-accordion__content--active")) {
            content.removeClass("table-accordion__content--active");
            $(this).html('View details <img src="/img/icons/YellowArrow.svg" class="table__arrow-img"/>')
           
        }
        else {
            content.addClass("table-accordion__content--active");
            $(this).html('Hide details <img src="/img/icons/YellowArrow.svg" class="table__arrow-img" />')
          
        }
 

    });


});

